<template>
  <!-- TooltipComponent template file -->
  <transition appear>
    <div
      v-portal="'#tooltip-portal'"
      class="tooltip-component-container"
      :style="getPosition"
      :class="[
        position,
        { multiline },
        { multilineSmall },
        { multilineManual },
      ]"
    >
      <p>{{ text }}</p>
    </div>
  </transition>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import vPortal from '@/directives/portal'

defineOptions({ name: 'TooltipComponent' })

const props = withDefaults(
  defineProps<{
    bbox?: DOMRect
    text: string | number
    position?: string
    margin?: number
    multiline?: boolean
    multilineSmall?: boolean
    multilineManual?: boolean
  }>(),
  {
    position: 'top',
    margin: 12,
    multiline: false,
    multilineSmall: false,
    multilineManual: false,
  },
)

const getPosition = computed(() => {
  if (!props.bbox) return {}
  if (props.position === 'bottom') {
    return {
      top: props.bbox.top + props.bbox.height + 'px',
      left: props.bbox.left + props.bbox.width / 2 + 'px',
    }
  } else if (props.position === 'left') {
    return {
      top: props.bbox.top - props.bbox.height / 2 + 'px',
      left: props.bbox.left - props.margin + 'px',
    }
  } else if (props.position === 'right') {
    return {
      top: props.bbox.top - props.bbox.height / 2 + 'px',
      left: props.bbox.left + props.bbox.width + props.margin + 'px',
    }
  } else {
    return {
      top: props.bbox.top - props.margin + 'px',
      left: props.bbox.left + props.bbox.width / 2 + 'px',
    }
  }
})
</script>
<style scoped lang="scss" src="./tooltip-component.scss"></style>
